import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Waiting.
 *
 * Six console screens each wrote this, five of them identically and one of
 * them at a different height, which is the exact shape of a thing that should
 * have been one component. Extracting it fixed two real problems rather than
 * only removing duplication:
 *
 * **A bare `<CircularProgress>` announces nothing.** MUI gives it
 * `role="progressbar"` and no accessible name, so a screen reader reaches a
 * page that is loading and is told "progress bar" — true, and useless.
 * `label` is required-shaped for that reason: it is what the control is
 * called, and it is rendered under the spinner as well, because a sighted
 * reader on a slow connection also wants to know which of four requests is
 * the slow one.
 *
 * **A spinner in a box that is smaller than the content moves the page.** The
 * console's spinners were `py: 6` and `py: 8` and neither matched what
 * arrived, so every screen jumped on resolve. `minHeight` gives the block a
 * size that survives the swap.
 */
export default function Loading({
  label = "Loading",
  minHeight = 200,
  size = 32,
  sx,
}) {
  return (
    <Box
      sx={{
        display: "grid",
        placeItems: "center",
        gap: 1.5,
        minHeight,
        py: 4,
        ...sx,
      }}
    >
      <CircularProgress size={size} aria-label={label} />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}
